import type { ProductProfileDto } from "../../types/ProductProfileDto";
import type { ProductProfileEntity } from "../../types/ProductProfileEntity";

export const ProductProfileEntityToDto = ({ ...rest }: Readonly<ProductProfileEntity>): ProductProfileDto => {
    return { ...rest };
};
